import React from "react";

import "./Mindset.css";

const mindset = () => {
  return (
    <div className="Mindset">
      <div className="spacer"></div>
      <div className="spacer"></div>
      <h5>Coming Soon</h5>
      <h2>Mindset</h2>
      <h5>Sponsored by</h5>
      <img
        alt="Growing Runners Logo"
        className="Logo"
        src="https://s3.us-east-2.amazonaws.com/districttrack/assets/media/partners/growing-runners-transparent.png"
      />
      <h4>Growing Runners</h4>
      <div className="spacer"></div>
      <div className="spacer"></div>
      <div className="spacer"></div>
    </div>
  );
};

export default mindset;
